import {
  React,
  Component,
  withRouter,
} from 'imports/CommonImports';

import {ChangePassword} from 'imports/ComponentsImports';

class ProfileView extends Component {

  render() {
    return (
      <div>
        <ChangePassword />
      </div>
    );
  }
}

export default withRouter(ProfileView);



// WEBPACK FOOTER //
// ./src/views/common/ProfileView.js